
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "191.94px",
    "viewBox": "0 0 1067 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M923.451915 325.174468h-202.686638V133.795404C720.765277 59.936681 670.044596 0 596.316596 0H133.773617A133.926128 133.926128 0 0 0 0 133.795404V1024h1046.615149V447.509787c0-67.475064-55.68817-122.335319-123.163234-122.335319zM245.237106 958.638298v-180.61617c0-8.475234 7.843404-15.468936 17.364426-15.468937h194.254979c9.499234 0 17.364426 6.993702 17.364425 15.468937V958.638298h-228.98383z m292.297532-167.108085c0-52.180426-42.332596-94.709106-94.295149-94.709107h-167.238808c-51.962553 0-94.295149 42.528681-94.295149 94.68732v166.999148H65.361702V122.64034A57.213277 57.213277 0 0 1 122.400681 65.361702h474.177362A57.213277 57.213277 0 0 1 653.617021 122.64034v197.021958L653.486298 958.638298h-115.95166v-167.108085z m185.017192 166.454468l-0.326809-563.025702h210.856851c24.358128 0 46.995064 28.192681 46.995064 52.681532v510.322383h-257.525106z",
        "fill": "#ffffff"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M484.98383 261.446809H212.338383C191.291915 261.446809 174.297872 276.044255 174.297872 294.12766S191.291915 326.808511 212.316596 326.808511h272.558298c21.046468 0 38.018723-14.597447 38.018723-32.680851s-16.994043-32.680851-37.909787-32.680851z m0 217.87234H212.338383C191.291915 479.319149 174.297872 493.916596 174.297872 512S191.291915 544.680851 212.316596 544.680851h272.558298c21.046468 0 38.018723-14.597447 38.018723-32.680851 0.130723-18.083404-16.994043-32.680851-37.909787-32.680851z",
        "fill": "#ffffff"
      }
    }
  ]
})
    }
  